import {
  ChangeDetectionStrategy,
  Component,
  inject,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BdShareablesService } from '@bindoc-projects/bindoc-permissions-lib/data';
import { ButtonDirective } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { BdUiDialogPrimaryActionDirective } from '@bindoc-projects/ui-lib/dialog/ui';

export interface CreateFolderDialogData {
  parentFolderId: string;
}

@Component({
  selector: 'bd-create-folder-dialog',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="flex flex-col gap-3 p-4 min-w-[320px]">
      <label class="text-sm">Ordnername</label>
      <input
        pInputText
        type="text"
        required
        [(ngModel)]="folderName"
        autofocus
      />
      <div class="flex justify-end gap-2 pt-2">
        <button pButton text (click)="cancel()"><span>Abbrechen</span></button>
        <button
          pButton
          bdDialogPrimaryAction
          [disabled]="!folderName().trim() || submitting()"
          (click)="submit()"
        >
          <span>Erstellen</span>
        </button>
      </div>
    </div>
  `,
  imports: [
    BdUiDialogPrimaryActionDirective,
    FormsModule,
    ButtonDirective,
    InputTextModule,
  ],
})
export class BdCreateFolderDialogComponent {
  private readonly _ref = inject(DynamicDialogRef);
  private readonly _config =
    inject<DynamicDialogConfig<CreateFolderDialogData>>(DynamicDialogConfig);
  private readonly _resourcesService = inject(BdShareablesService);

  public readonly folderName = signal('');
  public readonly submitting = signal(false);

  public submit(): void {
    const name = this.folderName().trim();
    if (!name || this.submitting()) {
      return;
    }
    const parentId = this._config.data?.parentFolderId;
    if (!parentId) {
      this._ref.close(null);
      return;
    }
    this.submitting.set(true);
    this._resourcesService.createFolder(name, parentId).subscribe({
      next: (folder) => this._ref.close(folder),
      error: () => {
        this.submitting.set(false);
      },
    });
  }

  public cancel(): void {
    this._ref.close(null);
  }
}
